import request from "@/utils/request";

//分页查询代金券发布信息
export function getVoucherInfoPage(data) {
  return request({
    url: "/marketing/voucherInfo/page",
    method: "get",
    params: data,
  });
}
// 添加代金券
export function addVoucherInfo(data) {
  return request({
    url: "/marketing/voucherInfo/add",
    method: "post",
    data: data,
  });
}
// 发布代金券
export function publishVoucherInfo(id) {
  return request({
    url: `/marketing/voucherInfo/issue/${id}`,
    method: "put",
  });
}
//  停用代金券
export function stopVoucherInfo(id) {
  return request({
    url: `/marketing/voucherInfo/stop/${id}`,
    method: "put",
  });
}
// 作废代金券
export function cancelVoucherInfo(id) {
  return request({
    url: `/marketing/voucherInfo/cancellation/${id}`,
    method: "put",
  });
}
// 删除代金券
export function deleteVoucherInfo(id) {
  return request({
    url: `/marketing/voucherInfo/${id}`,
    method: "put",
  });
}
// 查看代金券详情

export function getVoucherInfoDetail(id) {
  return request({
    url: `/marketing/voucherInfo/${id}`,
    method: "get",
  });
}
// 编辑代金券
export function editVoucherInfo(data) {
  return request({
    url: `/marketing/voucherInfo/edit`,
    method: "post",
    data: data,
  });
}
// 分页查询代金券关联商品表
export function getVoucherGoodsSkuPage(data) {
  return request({
    url: "/marketing/voucherGoodsSku/page",
    method: "get",
    params: data,
  });
}
// 移除代金券关联商品
export function voucherGoodsSkuEdit(data) {
  return request({
    url: `/marketing/voucherGoodsSku/edit`,
    method: "patch",
    data,
  });
}
// 删除代金券关联商品
export function voucherGoodsSkuDelete(id) {
  return request({
    url: `/marketing/voucherGoodsSku/${id}`,
    method: "delete",
  });
}
// 新增代金券关联商品
export function voucherGoodsSkuAdd(data) {
  return request({
    url: `/marketing/voucherGoodsSku/add`,
    method: "post",
    data,
  });
}
// 代金券绑定商品列表查询
export function querySkuPageByVoucher(data) {
  return request({
    url: "/product/stock/sku/querySkuPageByVoucher",
    method: "post",
    data,
  });
}
// 分页查询代金券单次发放记录
export function getVoucherSendRecordPage(data) {
  return request({
    url: "/marketing/voucherSendRecord/page",
    method: "get",
    params: data,
  });
}
// 发券
export function sendVoucher(data) {
  return request({
    url: "/marketing/voucherSendRecord/issue",
    method: "post",
    data,
  });
}
// 撤回发的券
export function voucherSendRecordWithdraw(data) {
  return request({
    url: `/marketing/voucherSendRecord/withdraw?id=${data.id}`,
    method: "put",
  });
}
// 模糊搜索代金券
export function fuzzySearchVoucher(data) {
  return request({
    url: "/marketing/voucherInfo/pull/down/list",
    method: "get",
    params: data,
  });
}
// 模糊搜索商户
export function fuzzySearchMerchant(data) {
  return request({
    url: "/shop/shop/searchByName",
    method: "get",
    params: data,
  });
}
